<template>
  <div class="ocpc-box">
    <crumb-tit :roots="routerLinks">
      <span slot="breadTit">{{ isSettingPage ? breadTit : 'oCPC' }}</span>
      <span slot="secondTit">oCPC</span>
    </crumb-tit>
    <a-tabs
      v-model="key"
      :animated="false"
      @change="onChange"
    >
      <a-tab-pane
        :key="1"
        :tab="recordTitTxt"
        force-render
      >
        <record-list v-if="type==='ocpcList'" />
      </a-tab-pane>
      <a-tab-pane
        :key="2"
        :tab="setTit"
        force-render
      >
        <setting-list v-if="type==='setList'" />
        <setting v-if="type==='setting'" />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
import CrumbTit from '@/components/pc/config/CrumbTit'
import RecordList from './RecordList'
import SettingList from './SettingList'
import Setting from './SettingForm'
import { getLang } from '@/lib/storage'
import { mapState } from 'vuex'
export default {
  components: {
    CrumbTit,
    RecordList,
    SettingList,
    Setting
  },
  props: {
    type: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      key: this.type === 'ocpcList' ? 1 : 2
    }
  },
  computed: {
    ...mapState('config/ocpc', ['isRecordDataReady', 'datas', 'datasReady', 'channelType']),
    isEnglish () {
      return this.getLang() === 'en'
    },
    isSettingPage () {
      return this.type === 'setting'
    },
    routerLinks () {
      return this.isSettingPage ? [
        { to: 'configIndex', title: this.$t('message["1326"]') },
        { to: 'ocpc', title: 'oCPC' },
        { to: 'setList', title: this.$t('message["1826"]') }
      ] : { to: 'configIndex', title: this.$t('message["1326"]') }
    },
    recordTitTxt () {
      return this.$t('message["1825"]')
    },
    setTit () {
      return this.$t('message["1826"]')
    },
    breadTit () {
      const { channelType } = this
      const tit = channelType[ this.$route.query.type * 1 - 1 ]
      return tit ? this.$t('message["1862"]') + tit : ''
    },
    comProjectName () {
      const { projectname = '', comname = '' } = this.$store.state.baseinfo
      return `- ${projectname} - ${comname}`
    }
  },
  mounted () {
    // console.log(this.isRecordDataReady)
    // if (this.isRecordDataReady || this.datasReady) {
    //   const { projectname = '', comname = '' } = this.$store.state.baseinfo
    //   document.title = 'oCPC' + `- ${projectname} - ${comname}`
    // }
  },
  methods: {
    getLang,
    onChange (key) {
      this.key = key
      this.LinkPath = key === 1
        ? 'ocpc'
        : 'setList'
      this.$router.push({
        name: this.LinkPath
      })
    }
  }
}
</script>
<style lang="scss" scoped >
.ocpc-box::v-deep {
  .ant-tabs {
    overflow: visible;
  }
   .ant-tabs-bar {
      border-bottom: none 0;
    }
    .ant-tabs-nav .ant-tabs-tab {
      font-size: 18px;
      font-weight: bold;
      padding: 12px 0;

    }
}
</style>
